// import React, { useState, useEffect, useRef } from "react";
// import { FaSpinner } from "react-icons/fa";
// import toast from "react-hot-toast";
// import { VoltSDKType } from "../../types/sdk";
// import voltService from "../../services/api/volt.service";
// import { useAuth } from "../../providers/auth.provider";

// // Define types
// interface SSOTokenData {
//     sso_token: string;
//     auth_token: string;
//     customer_code: string;
// }

// declare global {
//     interface Window {
//         Volt: VoltSDKType;
//         volt: unknown;
//     }
// }

// const ApplyLoan = () => {
//     const [loading, setLoading] = useState(false);
//     const [showSpinner, setShowSpinner] = useState(false);
//     const [ssoTokenData, setSsoTokenData] = useState<SSOTokenData | null>(null);
//     const [stage, setStage] = useState<'INITIAL' | 'SDK_READY' | 'SDK_LOADED'>('INITIAL');
//     const sdkInitialized = useRef(false);
//     const scriptLoaded = useRef(false);
//     const ssoTokenFetched = useRef(false);
//     const spinnerTimeout = useRef<NodeJS.Timeout | null>(null);

//     // Config for SDK
//     const config = {
//         environment: process.env.REACT_APP_VOLT_SDK_ENV as string,
//         pColor: '14532d',
//         voltPlatformCode: 'LARK',
//         divId: 'volt-sdk-container',
//         launchMode: 'div',
//         iframeWidth: 550,
//         iframeHeight: 700,
//         showVoltLogo: false,
//         customLogoUrl: "https://www.larkfinserv.com/frontend/img/lark.png"
//     };

//     // Load Volt SDK script only once
//     useEffect(() => {
//         if (scriptLoaded.current) return;
//         scriptLoaded.current = true;
//         const script = document.createElement('script');
//         script.src = 'https://staging.voltmoney.in/sdk/VoltMoney-sdk-v1.13.js';
//         script.onload = () => {
//             if (!ssoTokenFetched.current) {
//                 ssoTokenFetched.current = true;
//                 fetchSSOToken();
//             }
//         };
//         document.body.appendChild(script);

//         return () => {
//             if (script.parentNode) {
//                 document.body.removeChild(script);
//             }
//             if (spinnerTimeout.current) {
//                 clearTimeout(spinnerTimeout.current);
//             }
//         };
//     }, []);

//     // Initialize SDK when SSO data is available and not already initialized
//     useEffect(() => {
//         if (
//             ssoTokenData?.sso_token &&
//             ssoTokenData?.auth_token &&
//             ssoTokenData?.customer_code &&
//             stage === 'SDK_READY' &&
//             !sdkInitialized.current
//         ) {
//             initializeSDK();
//         }
//     }, [ssoTokenData, stage]);

//     // Show spinner for 5 seconds after SDK is ready
//     useEffect(() => {
//         if (stage === 'SDK_READY') {
//             setShowSpinner(true);
//             spinnerTimeout.current = setTimeout(() => {
//                 setShowSpinner(false);
//                 setStage('SDK_LOADED');
//             }, 5000);
//         }
//         return () => {
//             if (spinnerTimeout.current) {
//                 clearTimeout(spinnerTimeout.current);
//             }
//         };
//     }, [stage]);

//     // Fetch SSO token (calls backend, which now handles customer creation and returns tokens)
//     const fetchSSOToken = async () => {
//         if (loading) return;
//         try {
//             setLoading(true);
//             const response = await voltService.fetchSSOToken();
//             const data = response.data;
//             if (data.stage === "COMPLETE" && data.sso_token && data.auth_token && data.customer_code) {
//                 setSsoTokenData({
//                     sso_token: data.sso_token,
//                     auth_token: data.auth_token,
//                     customer_code: data.customer_code
//                 });
//                 setStage('SDK_READY');
//             } else {
//                 toast.error("Could not fetch SSO token. Please try again.");
//             }
//         } catch (error) {
//             console.error("Error fetching SSO token:", error);
//             toast.error("Failed to fetch authentication token. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Initialize SDK - only runs once due to sdkInitialized ref
//     const initializeSDK = () => {
//         if (sdkInitialized.current) return;
//         try {
//             sdkInitialized.current = true;

//             const VoltSDK = window.Volt;
//             const sdkObj = new VoltSDK({
//                 environment: config.environment,
//                 pColor: config.pColor,
//                 voltPlatformCode: config.voltPlatformCode,
//                 customerSsoToken: ssoTokenData?.sso_token as string,
//                 divId: config.divId,
//                 launchMode: config.launchMode,
//                 iframeWidth: config.iframeWidth as unknown as string,
//                 iframeHeight: config.iframeHeight as unknown as string,
//             });
//             window.volt = sdkObj;

//             sdkObj.submit(
//                 ssoTokenData?.auth_token,
//                 ssoTokenData?.customer_code,
//                 ssoTokenData?.sso_token
//             );
//         } catch (error) {
//             console.error("Error initializing SDK:", error);
//             toast.error("Failed to initialize Volt SDK.");
//         }
//     };

//     // On mount, immediately start loading flow (no button, no text)
//     useEffect(() => {
//         if (!ssoTokenFetched.current && scriptLoaded.current) {
//             ssoTokenFetched.current = true;
//             fetchSSOToken();
//         }
//     }, []);

//     // Render: Only spinner or SDK (no button, no text)
//     return (
//         <div style={{ position: "relative", minHeight: "400px" }}>
//             {showSpinner && (
//                 <div
//                     style={{
//                         position: "fixed",
//                         top: 0,
//                         left: 0,
//                         width: "100vw",
//                         height: "100vh",
//                         background: "rgba(255,255,255,0.85)",
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         zIndex: 9999
//                     }}
//                 >
//                     <FaSpinner className="animate-spin" size={48} color="#14532d" />
//                 </div>
//             )}
//             {/* SDK container is always rendered, but hidden while spinner is up */}
//             <div
//                 id="volt-sdk-container"
//                 style={{
//                     display: showSpinner ? "none" : "block",
//                     marginTop: 24
//                 }}
//             ></div>
//         </div>
//     );
// };

// export default ApplyLoan;
import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { VoltSDKType } from "../../types/sdk";
import voltService from "../../services/api/volt.service";
import { useAuth } from "../../providers/auth.provider";
import { MdErrorOutline } from "react-icons/md"; // For error icon

// Define types
interface SSOTokenData {
    sso_token: string;
    auth_token: string;
    customer_code: string;
}

declare global {
    interface Window {
        Volt: VoltSDKType;
        volt: unknown;
    }
}

const SDK_WIDTH = 550;
const SDK_HEIGHT = 700;
const LOADING_DURATION = 5000; // ms (5 seconds, change as needed)

const ApplyLoan = () => {
    const [loading, setLoading] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [dotCount, setDotCount] = useState(1);
    const [ssoTokenData, setSsoTokenData] = useState<SSOTokenData | null>(null);
    const [stage, setStage] = useState<'INITIAL' | 'SDK_READY' | 'SDK_LOADED'>('INITIAL');
    const [errorOverlay, setErrorOverlay] = useState("");
    const sdkInitialized = useRef(false);
    const scriptLoaded = useRef(false);
    const ssoTokenFetched = useRef(false);
    const overlayTimeout = useRef<NodeJS.Timeout | null>(null);
    const dotsInterval = useRef<NodeJS.Timeout | null>(null);

    // Config for SDK
    const config = {
        environment: process.env.REACT_APP_VOLT_SDK_ENV as string,
        pColor: '14532d',
        voltPlatformCode: 'LARK',
        divId: 'volt-sdk-container',
        launchMode: 'div',
        iframeWidth: SDK_WIDTH,
        iframeHeight: SDK_HEIGHT,
        showVoltLogo: false,
        customLogoUrl: "https://www.larkfinserv.com/frontend/img/lark.png"
    };

    // Load Volt SDK script only once
    useEffect(() => {
        if (scriptLoaded.current) return;
        scriptLoaded.current = true;
        const script = document.createElement('script');
        script.src = 'https://staging.voltmoney.in/sdk/VoltMoney-sdk-v1.13.js';
        script.onload = () => {
            if (!ssoTokenFetched.current) {
                ssoTokenFetched.current = true;
                fetchSSOToken();
            }
        };
        document.body.appendChild(script);

        return () => {
            if (script.parentNode) {
                document.body.removeChild(script);
            }
            if (overlayTimeout.current) {
                clearTimeout(overlayTimeout.current);
            }
            if (dotsInterval.current) {
                clearInterval(dotsInterval.current);
            }
        };
    }, []);

    // Initialize SDK when SSO data is available and not already initialized
    useEffect(() => {
        if (
            ssoTokenData?.sso_token &&
            ssoTokenData?.auth_token &&
            ssoTokenData?.customer_code &&
            stage === 'SDK_READY' &&
            !sdkInitialized.current
        ) {
            initializeSDK();
        }
    }, [ssoTokenData, stage]);

    // Show overlay for LOADING_DURATION ms after SDK is ready
    useEffect(() => {
        if (stage === 'SDK_READY') {
            setShowOverlay(true);
            setDotCount(1); // start with 1 dot
            overlayTimeout.current = setTimeout(() => {
                setShowOverlay(false);
                setStage('SDK_LOADED');
            }, LOADING_DURATION);

            // Start animated dots
            dotsInterval.current = setInterval(() => {
                setDotCount(prev => (prev === 3 ? 1 : prev + 1));
            }, 500);
        } else {
            if (dotsInterval.current) {
                clearInterval(dotsInterval.current);
            }
        }
        return () => {
            if (overlayTimeout.current) {
                clearTimeout(overlayTimeout.current);
            }
            if (dotsInterval.current) {
                clearInterval(dotsInterval.current);
            }
        };
    }, [stage]);

    // Fetch SSO token (calls backend, which now handles customer creation and returns tokens)
    const fetchSSOToken = async () => {
        if (loading) return;
        try {
            setLoading(true);
            setErrorOverlay(""); // clear error
            const response = await voltService.fetchSSOToken();
            const data = response.data;
            if (data.stage === "COMPLETE" && data.sso_token && data.auth_token && data.customer_code) {
                setSsoTokenData({
                    sso_token: data.sso_token,
                    auth_token: data.auth_token,
                    customer_code: data.customer_code
                });
                setStage('SDK_READY');
            } else {
                setErrorOverlay("Try again after some time or Contact our team.");
            }
        } catch (error) {
            console.error("Error fetching SSO token:", error);
            setErrorOverlay("Try again after some time or Contact our team.");
        } finally {
            setLoading(false);
        }
    };

    // Initialize SDK - only runs once due to sdkInitialized ref
    const initializeSDK = () => {
        if (sdkInitialized.current) return;
        try {
            sdkInitialized.current = true;

            const VoltSDK = window.Volt;
            const sdkObj = new VoltSDK({
                environment: config.environment,
                pColor: config.pColor,
                voltPlatformCode: config.voltPlatformCode,
                customerSsoToken: ssoTokenData?.sso_token as string,
                divId: config.divId,
                launchMode: config.launchMode,
                iframeWidth: config.iframeWidth as unknown as string,
                iframeHeight: config.iframeHeight as unknown as string,
            });
            window.volt = sdkObj;

            sdkObj.submit(
                ssoTokenData?.auth_token,
                ssoTokenData?.customer_code,
                ssoTokenData?.sso_token
            );
        } catch (error) {
            console.error("Error initializing SDK:", error);
            toast.error("Failed to initialize Volt SDK.");
        }
    };

    // On mount, immediately start loading flow (no button, no text)
    useEffect(() => {
        if (!ssoTokenFetched.current && scriptLoaded.current) {
            ssoTokenFetched.current = true;
            fetchSSOToken();
        }
    }, []);

    // Overlay with "Please wait" and animated dots, top-centered above SDK
    const PleaseWaitOverlay = () => (
        <div
            style={{
                position: "absolute",
                top: 20,
                left: 0,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                zIndex: 20,
                pointerEvents: "none"
            }}
        >
            <span
                style={{
                    fontWeight: 600,
                    fontSize: 22,
                    color: "#14532d",
                    letterSpacing: "0.04em",
                    fontFamily: "inherit",
                    background: "rgba(255,255,255,0.96)",
                    padding: "6px 24px",
                    borderRadius: 8,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.04)"
                }}
            >
                Please wait{".".repeat(dotCount)}
            </span>
        </div>
    );

    // Improved Error Overlay: left-aligned, vertically centered, modern UI
    const ErrorOverlay = () => (
        <div
            style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 2,
                backgroundColor: "transparent",
                pointerEvents: "none",
            }}
        >
            <div
                style={{
                    backgroundColor: "#ecfdf5",
                    border: "1.5px solid #22c55e",
                    borderRadius: 10,
                    padding: "20px 28px",
                    textAlign: "center",
                    maxWidth: "85%",
                    boxShadow: "0 6px 16px rgba(34,197,94,0.15)",
                    color: "#14532d",
                    fontFamily: "inherit",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center", // ✅ ensures icon + text are horizontally centered
                    justifyContent: "center",
                }}
            >
                <MdErrorOutline
                    size={36}
                    color="#16a34a"
                    style={{ marginBottom: 10 }}
                />
                <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 4 }}>
                    Something went wrong
                </div>
                <div style={{ fontSize: 14, fontWeight: 500 }}>
                    Try again after some time or contact our team.
                </div>
            </div>
        </div>
    );

    // Render: SDK container in its original position, overlay please wait or error if needed
    return (
        <div
            style={{
                width: SDK_WIDTH,
                height: SDK_HEIGHT,
                borderRadius: 8,
                overflow: "hidden",
                position: "relative"
            }}
        >
            <div
                id="volt-sdk-container"
                style={{
                    width: "100%",
                    height: "100%",
                    position: "relative"
                }}
            ></div>
            {errorOverlay
                ? <ErrorOverlay />
                : showOverlay && <PleaseWaitOverlay />
            }
        </div>
    );
};

export default ApplyLoan;
